<template>
  <div class="ui segment">
    <h3>Seleccione el método de envio</h3>

    <sui-dropdown
      placeholder="Seleccione paqueteria"
      selection
      :options="shippings"
      v-model="current"
    />

    <br />
    <br />
    <div v-if="shipping" class="">
      <div class="item">
        <div class="content">
          <a class="header"
            ><h4>{{ shipping.name }}</h4></a
          >
          <div class="meta">
            <span class="stay">{{ shipping.description }}</span>
            <span class="price">{{
              shipping.price | numeralFormat('$0,0.00')
            }}</span>
          </div>
          <br />
          <div>
            <sui-checkbox
              v-if="false"
              :label="
                `Asegura tu envio por el ${shipping.percentage}% adicional sobre el valor del pedido`
              "
              toggle
              v-model="secured"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShippingSelector',
  data: function() {
    return {
      current: null,
      secured: true
    };
  },
  computed: {
    shippings: function() {
      return this.$store.getters['shipping/getShippings'].map(s => {
        return { text: s.name, value: s._id };
      });
    },
    shipping: function() {
      if (this.current !== null)
        return this.$store.getters['shipping/getShippings'].find(
          s => s._id === this.current
        );
    }
  },
  watch: {
    current: function(val) {
      if (val !== null) this.$emit('onSelected', this.shipping);
    },
    secured: function(val) {
      this.$emit('onSecured', true);
    }
  },
  created: async function() {
    await this.$store.dispatch('shipping/loadShippings');
  }
};
</script>

<style lang="css" scoped></style>
